/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  CreateRandomPromoAction200Response,
  CreateRandomPromoAction400Response,
  Registration429Response,
} from '../models/index'
import {
  CreateRandomPromoAction200ResponseFromJSON,
  CreateRandomPromoAction200ResponseToJSON,
  CreateRandomPromoAction400ResponseFromJSON,
  CreateRandomPromoAction400ResponseToJSON,
  Registration429ResponseFromJSON,
  Registration429ResponseToJSON,
} from '../models/index'

export interface CreateRandomPromoActionRequest {
  promoActionGroup: string
}

/**
 * PublicPromoCodesApi - interface
 *
 * @export
 * @interface PublicPromoCodesApiInterface
 */
export interface PublicPromoCodesApiInterface {
  /**
   * Создаёт промокод со случайной промо-акцией указанной группы: тип бонуса выбирается случайно — процент скидки (10–100), фиксированная сумма (500–3000 ₽) или бесплатная услуга. Промокод действует один месяц с момента создания. Публичный эндпоинт без авторизации (защищён middleware site-verify, лимит 10 запросов в минуту).
   * @summary Создать случайную промо-акцию
   * @param {string} promoActionGroup Группа промо-акций
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPromoCodesApiInterface
   */
  createRandomPromoActionRaw(
    requestParameters: CreateRandomPromoActionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateRandomPromoAction200Response>>

  /**
   * Создаёт промокод со случайной промо-акцией указанной группы: тип бонуса выбирается случайно — процент скидки (10–100), фиксированная сумма (500–3000 ₽) или бесплатная услуга. Промокод действует один месяц с момента создания. Публичный эндпоинт без авторизации (защищён middleware site-verify, лимит 10 запросов в минуту).
   * Создать случайную промо-акцию
   */
  createRandomPromoAction(
    requestParameters: CreateRandomPromoActionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateRandomPromoAction200Response>
}

/**
 *
 */
export class PublicPromoCodesApi
  extends runtime.BaseAPI
  implements PublicPromoCodesApiInterface
{
  /**
   * Создаёт промокод со случайной промо-акцией указанной группы: тип бонуса выбирается случайно — процент скидки (10–100), фиксированная сумма (500–3000 ₽) или бесплатная услуга. Промокод действует один месяц с момента создания. Публичный эндпоинт без авторизации (защищён middleware site-verify, лимит 10 запросов в минуту).
   * Создать случайную промо-акцию
   */
  async createRandomPromoActionRaw(
    requestParameters: CreateRandomPromoActionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateRandomPromoAction200Response>> {
    if (requestParameters['promoActionGroup'] == null) {
      throw new runtime.RequiredError(
        'promoActionGroup',
        'Required parameter "promoActionGroup" was null or undefined when calling createRandomPromoAction().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/promo-codes/create-random-promo-action/{promoActionGroup}`.replace(
          `{${'promoActionGroup'}}`,
          encodeURIComponent(String(requestParameters['promoActionGroup']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateRandomPromoAction200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Создаёт промокод со случайной промо-акцией указанной группы: тип бонуса выбирается случайно — процент скидки (10–100), фиксированная сумма (500–3000 ₽) или бесплатная услуга. Промокод действует один месяц с момента создания. Публичный эндпоинт без авторизации (защищён middleware site-verify, лимит 10 запросов в минуту).
   * Создать случайную промо-акцию
   */
  async createRandomPromoAction(
    requestParameters: CreateRandomPromoActionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateRandomPromoAction200Response> {
    const response = await this.createRandomPromoActionRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}
